(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function initializeArcArticleToc(root) {
    root.querySelectorAll('[data-arc-article-body]').forEach((body) => {
      const toc = body.previousElementSibling;
      if (!toc || !toc.matches('[data-arc-toc]') || toc.dataset.ready) return;
      const headings = Array.from(body.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
      if (headings.length < 6 || body.textContent.trim().split(/\s+/).length < 900) return;
      const list = toc.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = `arc-heading-${body.dataset.arcArticleBody}-${index + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        const item = document.createElement('li');
        const anchor = document.createElement('a');
        anchor.href = `#${heading.id}`;
        anchor.textContent = heading.textContent.trim();
        item.append(anchor);
        list.append(item);
      });
      toc.dataset.ready = 'true';
      toc.hidden = false;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeArcArticleToc(document), { once: true });
  } else {
    initializeArcArticleToc(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeArcArticleToc(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
